"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODAL_Z_INDEX = exports.MDL = exports.CSS = void 0;
const input_1 = require("../input/input");
const theme_1 = require("../theme");
const theme_palette_1 = require("../theme.palette");
exports.CSS = {
    container: 'c-Modal',
    modal: 'c-Modal-Container',
    title: 'c-Modal-Title',
    actions: 'c-Modal-Actions',
    content: 'c-Modal-Content',
    action: {
        ok: 'c-Modal-Actions__Ok',
        cancel: 'c-Modal-Actions__Cancel'
    },
    isOpen: 'c-Modal--open'
};
exports.MDL = {
    button: 'mdl-button'
};
exports.MODAL_Z_INDEX = 100;
(0, theme_1.addStyles)({
    [exports.CSS.container]: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        width: '100%',
        height: '100%',
        'background-color': theme_1.DefaultTheme.font.color.supporting,
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        'z-index': exports.MODAL_Z_INDEX - 1,
        [`& .${input_1.Input.CSS.container}`]: {
            width: '100%'
        }
    },
    [exports.CSS.modal]: {
        'z-index': exports.MODAL_Z_INDEX,
        'min-width': '280px',
        'max-height': '90%',
        background: theme_1.DefaultTheme.background.offWhite,
        display: 'flex',
        'flex-direction': 'column',
        margin: 0,
        width: 'auto',
        height: 'auto',
        opacity: 0,
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
        transition: 'opacity 0.25s ease'
    },
    [exports.CSS.isOpen + ' .' + exports.CSS.modal]: {
        opacity: 1
    },
    [exports.CSS.title]: {
        color: (0, theme_1.rgba)(theme_palette_1.WHITE),
        padding: `${theme_1.DefaultTheme.space(2)} ${theme_1.DefaultTheme.space(6)}`,
        'font-size': theme_1.DefaultTheme.font.size * 1.1 + 'px',
        'background-color': theme_1.DefaultTheme.background.darkGrey
    },
    [exports.CSS.content]: {
        color: theme_1.DefaultTheme.font.color.supporting,
        padding: theme_1.DefaultTheme.space(6),
        'padding-bottom': theme_1.DefaultTheme.space(1),
        overflow: 'auto'
    },
    [exports.CSS.actions]: {
        'text-align': 'right',
        padding: theme_1.DefaultTheme.space(2),
        [`& .${exports.CSS.action.ok}`]: {
            color: theme_1.DefaultTheme.color.accent
        }
    }
});
//# sourceMappingURL=modal.style.js.map